import { APIProvider } from "@vis.gl/react-google-maps";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

interface GoogleMapsContextType {
  mapId: string;
}

const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(undefined);

export const useGoogleMaps = (): GoogleMapsContextType | undefined => {
  return useContext(GoogleMapsContext);
};

interface GoogleMapsProviderProps {
  apiKey: string;
  mapId: string;
  children: ReactNode;
}

export const GoogleMapsProvider = ({ apiKey, mapId, children }: GoogleMapsProviderProps) => {
  return (
    <GoogleMapsContext.Provider value={{ mapId }}>
      <APIProvider apiKey={apiKey}>{children}</APIProvider>
    </GoogleMapsContext.Provider>
  );
};